import type { Dir, Pos } from '@xox/shared'

/** Shared timing so the board, solo mode and race store animate slides identically. */
const GLIDE_MS_PER_CELL = 55
export const FALL_MS = 340
/** How long a yeti takes to hop one cell after your move. */
export const YETI_STEP_MS = 220

export function glideMs(cells: number): number {
  return Math.min(480, Math.max(120, cells * GLIDE_MS_PER_CELL))
}

export type Facing = 'left' | 'right'

/** Direction of a slide from one stop to the next, or null when nothing moved. */
export function slideDir(prev: Pos, next: Pos): Dir | null {
  if (next.c !== prev.c) return next.c > prev.c ? 'right' : 'left'
  if (next.r !== prev.r) return next.r > prev.r ? 'down' : 'up'
  return null
}

/** Sprites turn to face horizontal travel and keep looking that way through vertical slides. */
export function facingAfter(prev: Pos, next: Pos, current: Facing): Facing {
  const dir = slideDir(prev, next)
  return dir === 'left' || dir === 'right' ? dir : current
}
